import { render } from "./anotherSite.vue?vue&type=template&id=79d17441&scoped=true"
import script from "./anotherSite.vue?vue&type=script&lang=js"
export * from "./anotherSite.vue?vue&type=script&lang=js"

import "./anotherSite.vue?vue&type=style&index=0&id=79d17441&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d17441"]])

export default __exports__